import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase-config';

// Firebase Functions for Early Bird promotion management
const setEarlyBirdPromoFunction = httpsCallable(functions, 'setEarlyBirdPromo');
const checkFreeListingQuotaFunction = httpsCallable(functions, 'checkFreeListingQuota');
const useFreeListingQuotaFunction = httpsCallable(functions, 'useFreeListingQuota');

/**
 * Set Early Bird promotion for a new user
 * @param {string} userId - User ID
 * @param {string} email - User email
 * @param {string} name - User name
 * @returns {Promise<Object>} Promotion data
 */
export const setEarlyBirdPromo = async (userId, email, name) => {
  try {
    const result = await setEarlyBirdPromoFunction({
      userId,
      email,
      name
    });
    
    // Send welcome email via PHP mailer
    try {
      const emailResponse = await fetch('/send_early_bird_email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId,
          email,
          name
        })
      });
      
      const emailResult = await emailResponse.json();
      console.log('Early Bird email sent:', emailResult);
    } catch (emailError) {
      console.error('Error sending Early Bird email:', emailError);
    }
    
    return {
      success: true,
      data: result.data
    };
  } catch (error) {
    console.error('Error setting Early Bird promo:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Check if user has free listing quota available
 * @param {string} userId - User ID
 * @returns {Promise<Object>} Quota check result
 */
export const checkFreeListingQuota = async (userId) => {
  try {
    const result = await checkFreeListingQuotaFunction({
      userId
    });
    
    return {
      success: true,
      hasFreeListing: result.data.hasFreeListing,
      remainingListings: result.data.remainingListings,
      message: result.data.message
    };
  } catch (error) {
    console.error('Error checking free listing quota:', error);
    return {
      success: false,
      hasFreeListing: false,
      error: error.message
    };
  }
};

/**
 * Use a free listing quota (decrement count)
 * @param {string} userId - User ID
 * @returns {Promise<Object>} Usage result
 */
export const useFreeListingQuota = async (userId) => {
  try {
    const result = await useFreeListingQuotaFunction({
      userId
    });
    
    return {
      success: true,
      usedListings: result.data.usedListings,
      remainingListings: result.data.remainingListings,
      message: result.data.message
    };
  } catch (error) {
    console.error('Error using free listing quota:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Helper function to check if user should get Early Bird promotion
 * @returns {boolean} Whether promo is still active
 */
export const isEarlyBirdPromoActive = () => {
  const promoEndDate = new Date('2025-09-30T23:59:59Z');
  const now = new Date();
  return now < promoEndDate;
};
